<template>
  <div class="mx-8 py-4">
    <div
        v-for="(utterance, index) in utterances"
        :id="`utterance_${utterance.id}`"
        :key="index"
        :class="classes(utterance)"
    >
      <MessageBalloon
          :owner="isOwner(utterance)"
          :system="isSystem(utterance)"
          :file="utterance.data"
          :createdAt="utterance.createdAt"
          :company="company"
          :requestor="requestor"
          class="message-balloon"
      >
        <div>
          <span v-for="(node, index) in parseNodes(trim(utterance.detail))" :key="index">
            <span v-if="node.type === 'text'" style="overflow-wrap: break-word">{{node.text}}</span>
            <a v-if="node.type === 'link'" :href="node.text" style="color: inherit; text-decoration: underline" target="_blank">{{node.text}}</a>
          </span>
        </div>
      </MessageBalloon>
    </div>
  </div>
</template>

<script>
import MessageBalloon from "@/components/atoms/MessageBalloon";
import ComponentMixin from "@/components/ComponentMixin";
import _trim from "lodash/trim"
export default {
  mixins: [ComponentMixin],
  name: "MessageBoard",
  components: {MessageBalloon},
  props: {
    utterances: {
      type: Array
    },
    candidate: {
      type: Boolean
    },
    company: {
      type: Object
    },
    requestor: {
      type: Object
    }
  },
  computed: {
    classes() {
      return (utterance) => {
        const values = ["d-flex", "flex-row"]
        if (this.isSystem(utterance)) {
          values.push("justify-center")
        } else if (this.isOwner(utterance)) {
          values.push("justify-end")
        } else {
          values.push("justify-start")
        }
        return values;
      }
    },
    isOwner() {
      return (utterance) => {
        if (utterance.whose === 3) {
          return false
        }
        if (this.candidate) {
          return utterance.whose === 1
        } else {
          return utterance.whose === 2
        }
      }
    },
    isSystem() {
      return (utterance) => {
        return utterance.whose === 3 || utterance.whose === 4
      }
    }
  },
  methods: {
    trim(value) {
      return _trim(value)
    },
    parseNodes(value) {
      const exp = /(.*)((https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])(.*)/ism
      const match = exp.exec(value)
      if (match) {
        return this.parseNodes(match[1]).concat([
            { text: match[2], type: 'link'},
        ]).concat(this.parseNodes(match[4]))
      } else {
        return [
          { text: value, type: 'text'}
        ]
      }
    }
  },
}
</script>

<style scoped>
.message-balloon {
  max-width: 80%;
  white-space: pre-line;
}
</style>